import { useState, useMemo } from "react";
import { useGetAppointmentsQuery } from "@/queries/useGetAppointmentsQuery";

export const useCalendar = () => {
  const [value, onChange] = useState(new Date());

  const { data: appointmentsData } = useGetAppointmentsQuery({ activeOnly: false });

  const dateArr = useMemo(() => {
    if (appointmentsData) {
      return appointmentsData.map((date) => {
        if (date.status === "canceled") {
          date.start_date = "";
        }

        return date.start_date.substr(0, 10);
      });
    }

    return [];
  }, [appointmentsData]);

  return {
    value,
    onChange,
    dateArr,
  };
};
